import React from "react";
import { Modal, Table } from "react-bootstrap";

const HistoryModal = ({
  show,
  onClose,
  title,
  headers = [],
  rows = [],
  renderRow, // Optional: custom row renderer
  footer,
}) => (
  <Modal show={show} onHide={onClose} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {rows && rows.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              {headers.map((header, idx) => (
                <th key={idx}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) =>
              renderRow ? (
                renderRow(row, idx)
              ) : (
                <tr key={row.id || idx}>
                  {headers.map((header, hIdx) => (
                    <td key={hIdx}>{row[header] ?? ""}</td>
                  ))}
                </tr>
              )
            )}
          </tbody>
        </Table>
      ) : (
        <div className="text-center py-4">
          <i className="fa fa-users fa-3x text-muted mb-3"></i>
          <p className="text-muted">No details available</p>
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      {footer}
      <button type="button" className="btn btn-secondary" onClick={onClose}>
        Close
      </button>
    </Modal.Footer>
  </Modal>
);

export default HistoryModal;
